import React from "react";

import AppSearchAPIConnector from "@elastic/search-ui-app-search-connector";

import {
  ErrorBoundary,
  SearchProvider,
  SearchBox,
  WithSearch
} from "@elastic/react-search-ui";
import "@elastic/react-search-ui-views/lib/styles/styles.css";

import {
  getConfig,
} from "../config/config-helper";

const { hostIdentifier, searchKey, endpointBase, engineName } = getConfig();
const connector = new AppSearchAPIConnector({
  searchKey,
  engineName,
  hostIdentifier,
  endpointBase
});
const config = {
  autocompleteQuery: {
    results: {
      filters: [],
      result_fields: {
        // Add snippet highlighting
        title: { snippet: { size: 100, fallback: true } },
        path: { raw: {} },
        type: { raw: {} },
        description: { snippet: { size: 100, fallback: true } },
      }
    },
  },
  apiConnector: connector,
  alwaysSearchOnInitialLoad: false
};

export default function App(props) {  
  config.autocompleteQuery.results.filters = [{ field: "lang", values: [props.languageCode] }];
  return (
    <SearchProvider config={config}>
      <WithSearch mapContextToProps={({ wasSearched }) => ({ wasSearched })}>
        {({ wasSearched }) => {
          return (
            <div className="search">
              <ErrorBoundary>
                <SearchBox placeholder="Search for text styles, emojis, and more..." autocompleteResults={{
                    titleField: "formatted",
                    urlField: "path"
                  }}
                  onSubmit={(e) => {
                    return false;
                  }}
                  inputView={({ getAutocomplete, getInputProps, getButtonProps }) => (
                    <>
                      <div className="sui-search-box__wrapper">
                        <input
                          {...getInputProps({
                            placeholder: "Search text styles, emojis, etc.",
                            onKeyDown: (e) => {
                              if (e.key === 'Enter') {
                                e.preventDefault();
                                return false;
                              }
                            }
                          })}
                        />
                        {getAutocomplete()}
                      </div>
                    </>
                  )}
                  mapContextToProps={context => {
                    if (!context.autocompletedResults) return context;
                    return {
                      ...context,
                      autocompletedResults: context.autocompletedResults.map((result) => {
                        result.formatted = {
                          snippet: `<span class="pill">${result.type.raw}</span> ${result.title.snippet}`  
                        };
                        return result;
                      })
                    };
                  }} />
              </ErrorBoundary>
            </div>
          );
        }}
      </WithSearch>
    </SearchProvider>
  );
}
